module.exports = __webpack_public_path__ + "static/z16-2-0001-5cb7bdea39ec17488cb68fe9530d9683.jpg";